module.exports = __webpack_public_path__ + "a0ece538659da48ae48aef4ad6de85e8.png";